import { render, staticRenderFns } from "./ElementInputNumber.vue?vue&type=template&id=207ed514&scoped=true"
import script from "./ElementInputNumber.vue?vue&type=script&lang=js"
export * from "./ElementInputNumber.vue?vue&type=script&lang=js"
import style0 from "./ElementInputNumber.vue?vue&type=style&index=0&id=207ed514&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "207ed514",
  null
  
)

export default component.exports